module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6n8n7r-855af7498c6544f3284e032f6c9fb4ed.svg";